import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';
import { finalize, Observable, take } from 'rxjs';

// Contador module-scope: sobrevive entre invocaciones del interceptor (una
// por request HTTP) para poder generar una clave única por llamada.
let requestCounter = 0;

export const fuseLoadingInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const fuseLoadingService = inject(FuseLoadingService);
    let handleRequestsAutomatically = false;

    fuseLoadingService.auto$
        .pipe(take(1))
        .subscribe((value) =>
        {
            handleRequestsAutomatically = value;
        });

    // If the Auto mode is turned off, do nothing
    if ( !handleRequestsAutomatically )
    {
        return next(req);
    }

    // Clave única por request (no la URL) — dos llamadas concurrentes al mismo
    // endpoint no deben pisarse la una a la otra en el Map del servicio.
    const requestKey = `${req.url}#${++requestCounter}`;

    // Set the loading status to true
    fuseLoadingService._setLoadingStatus(true, requestKey);

    return next(req).pipe(
        finalize(() =>
        {
            // Set the status to false if there are any errors or the request is completed
            fuseLoadingService._setLoadingStatus(false, requestKey);
        }));
};
